import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Collaborations from '../components/Collaborations';
import SeoHead from '../components/SeoHead';

const CollaborationsPage = () => {
  return (
    <div className="min-h-screen bg-cream">
      <SeoHead
        title="Clients & Partners – Carol Mezher | Collaborations"
        description="A global network of collaborations across film, media, culture and live experiences — including festivals, studios, broadcasters and cultural institutions."
        path="/collaborations"
        ogType="website"
      />
      <Header />

      {/* Hero — matches Services page hierarchy */}
      <section className="pt-32 pb-12 bg-midnight-blue">
        <div className="container mx-auto px-8 md:px-16">
          <div className="max-w-7xl mx-auto">
            <div className="text-center">
              <h1 className="font-playfair font-bold text-5xl md:text-6xl text-white mb-6">
                Clients & Partners
              </h1>
              <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" style={{ textAlign: 'center' }}>
                A global network of collaborations across film, media, culture,<br />and live experiences.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Collaborations grid (no internal header on this page) */}
      <Collaborations showHeader={false} />

      <Footer />
    </div>
  );
};

export default CollaborationsPage;
